import React from "react";

const introInfoItem = props => {
  return (
    <li className="content-info__item">
      <div className="info-item__title">
        {/* <div className="Prefix-sign"> {"//"} </div> */}
        <div className="info-item-title bold"> {props.title} </div>
        <div className="info-item-title-spacer"> : </div>
      </div>
      <div className="info-item__desc"> {props.children} </div>
    </li>
  );
};

export default introInfoItem;
